// extracted by mini-css-extract-plugin
export default {"cls1":"zH78S8TOLcMQFhojqv3G","cls2":"SmmisMXHoYSGDNuLzjm8 zH78S8TOLcMQFhojqv3G"};